/**
 * MockupTablasAcordeon V2 — propuesta integral del paso 2 ConstructorOferta:
 *  - Header refinado (3 filas más limpias y útiles)
 *  - Stepper Paso 1 / Paso 2 con CONTRASTE FUERTE (sabes cuál está presionado)
 *  - Tablas con shading reforzado en filas + columnas
 *  - Píldora destacada para fila MB
 */
import React, { useState } from "react";
import {
  ChevronDown, Leaf, Plus, Printer, History, UserPlus, Check, Settings, Calculator,
  TrendingUp, Wallet, Target, ChevronRight,
} from "lucide-react";

// Datos mock idénticos a la foto del cliente
const TABLA_B1 = {
  titulo: "OPERACIÓN POR VEHÍCULO",
  headers: ["", "HW", "SAAS", "TOTAL"],
  rows: [
    { label: "VENTA",  vals: ["90 €",    "529 €",   "619 €"] },
    { label: "COSTE",  vals: ["62 €",    "324 €",   "386 €"] },
    { label: "MB",     vals: ["28 €",    "205 €",   "233 €"], kpi: true },
    { label: "%MB",    vals: ["31,1 %",  "38,7 %",  "37,6 %"] },
    { label: "CHECK",  vals: [{ chip: "OK", ok: true }, { chip: "BAJO", ok: false }, { chip: "OK", ok: true }], ultima: true },
  ],
};
const TABLA_B2 = {
  titulo: "OPERACIÓN POR FLOTA · 43 VEH · 36M",
  headers: ["", "HW", "SAAS", "TOTAL"],
  rows: [
    { label: "VENTA",  vals: ["3.870 €",  "22.756 €",  "26.626 €"] },
    { label: "COSTE",  vals: ["2.666 €",  "13.932 €",  "16.598 €"] },
    { label: "MB",     vals: ["1.204 €",  "8.824 €",   "10.028 €"], kpi: true },
    { label: "%MB",    vals: ["31,1 %",   "38,7 %",    "37,6 %"], ultima: true },
  ],
};

const PALETAS = {
  ambar: {
    headerBg: "bg-orange-100", headerText: "text-orange-900",
    labelText: "text-orange-900",
    rowAltBg: "bg-orange-50/60",        // shading suave alterno (zebra)
    colLabelBg: "bg-orange-100/70",     // columna izquierda — intensidad cercana al header
    colHeaderBg: "bg-orange-100/70",    // banda columnas HW/SAAS/TOTAL — intensidad cercana al header
    kpiBg: "bg-orange-200", kpiText: "text-orange-950",
  },
  azul: {
    headerBg: "bg-blue-100", headerText: "text-blue-900",
    labelText: "text-blue-900",
    rowAltBg: "bg-blue-50/60",
    colLabelBg: "bg-blue-100/70",
    colHeaderBg: "bg-blue-100/70",
    kpiBg: "bg-blue-200", kpiText: "text-blue-950",
  },
};

// ============================================================================
// Tabla — propuesta V2 con shading reforzado en filas y columnas
// ============================================================================
const TablaV2 = ({ tabla, paleta }) => {
  const [open, setOpen] = useState(true);
  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm">
      <button
        onClick={() => setOpen(o => !o)}
        className={`w-full px-4 py-2.5 text-xs font-bold uppercase tracking-wider flex items-center justify-between ${paleta.headerBg} ${paleta.headerText}`}
      >
        <span>{tabla.titulo}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <table className="w-full text-xs">
          <thead>
            <tr className={`border-b border-slate-200 ${paleta.colHeaderBg}`}>
              {tabla.headers.map((h, i) => (
                <th key={i} className={`px-4 py-2 text-[10px] font-black uppercase tracking-wider ${paleta.labelText} ${i === 0 ? "text-left" : "text-right"}`}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tabla.rows.map((r, idx) => {
              const ultima = r.ultima;
              const rowAlt = idx % 2 === 1 && !r.kpi ? paleta.rowAltBg : "";
              if (r.kpi) {
                // Fila MB destacada · banda completa color del header
                return (
                  <tr key={idx} className={`${paleta.kpiBg}`}>
                    <td className={`px-4 py-2.5 text-left text-[11px] font-black uppercase tracking-wider ${paleta.kpiText} ${ultima ? "" : "border-b border-white/70"}`}>{r.label}</td>
                    {r.vals.map((v, i) => (
                      <td key={i} className={`px-4 py-2.5 text-right text-[14px] font-black ${paleta.kpiText} ${ultima ? "" : "border-b border-white/70"}`}>{v}</td>
                    ))}
                  </tr>
                );
              }
              return (
                <tr key={idx} className={rowAlt}>
                  <td className={`px-4 py-2 text-left text-[10px] font-bold uppercase tracking-wider ${paleta.labelText} ${paleta.colLabelBg} ${ultima ? "" : "border-b border-slate-100"}`}>{r.label}</td>
                  {r.vals.map((v, i) => (
                    <td key={i} className={`px-4 py-2 text-right text-[13px] font-bold text-slate-900 ${ultima ? "" : "border-b border-slate-100"}`}>
                      {typeof v === "object" && v.chip ? (
                        <span className={`px-2.5 py-0.5 rounded-full text-[10px] font-bold ${v.ok ? "bg-emerald-100 text-emerald-700 border border-emerald-200" : "bg-rose-100 text-rose-700 border border-rose-200"}`}>{v.chip}</span>
                      ) : v}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

// ============================================================================
// Header viejo eliminado · ahora hay HeaderA / HeaderB / HeaderC más abajo
// ============================================================================

// ============================================================================
// Componente principal — selector de 3 propuestas de header
// ============================================================================
export default function MockupTablasAcordeon() {
  const [paso, setPaso] = useState(2);
  const [headerVariant, setHeaderVariant] = useState("A");

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Selector de variantes */}
      <div className="bg-slate-900 text-white px-6 py-3 sticky top-0 z-30">
        <div className="max-w-[1500px] mx-auto flex items-center gap-3 flex-wrap">
          <span className="text-xs font-bold uppercase tracking-wider text-emerald-300">Propuestas de header</span>
          {[
            { key: "A", label: "A · Compacto 3 filas" },
            { key: "B", label: "B · KPIs vivos" },
            { key: "C", label: "C · Minimalista" },
          ].map((v) => (
            <button
              key={v.key}
              onClick={() => setHeaderVariant(v.key)}
              data-testid={`mock-hdr-${v.key.toLowerCase()}`}
              className={`px-4 py-1.5 rounded-full text-xs font-bold transition-all ${
                headerVariant === v.key ? "bg-emerald-500 text-white shadow" : "bg-slate-800 text-slate-300 hover:bg-slate-700"
              }`}
            >
              {v.label}
            </button>
          ))}
          <div className="flex-1" />
          <span className="text-[10px] text-slate-400">Tablas: V2 ya aprobada · No toca lógica</span>
        </div>
      </div>

      {/* Render variant */}
      {headerVariant === "A" && <HeaderA paso={paso} setPaso={setPaso} />}
      {headerVariant === "B" && <HeaderB paso={paso} setPaso={setPaso} />}
      {headerVariant === "C" && <HeaderC paso={paso} setPaso={setPaso} />}

      <main className="max-w-[1500px] mx-auto px-6 py-6 space-y-4">
        {paso === 1 ? (
          <div className="bg-white border border-slate-200 rounded-lg p-8 text-center text-slate-500">
            <p className="text-sm">Aquí iría el contenido del paso 1 (Configurar) — modalidad, vehículos, productos HW, productos SaaS, reducciones, condiciones.</p>
            <p className="text-xs text-slate-400 mt-2">Vuelve al paso 2 para ver las tablas mejoradas.</p>
          </div>
        ) : (
          <>
            <h2 className="text-base font-bold text-slate-700 mb-2">Paso 2 · Vista comercial</h2>
            <div className="grid lg:grid-cols-2 gap-5">
              <TablaV2 tabla={TABLA_B1} paleta={PALETAS.ambar} />
              <TablaV2 tabla={TABLA_B2} paleta={PALETAS.azul} />
            </div>
          </>
        )}

        <div className="mt-8 bg-white border border-slate-200 rounded-xl p-6">
          <h3 className="text-base font-bold text-slate-900 mb-3">Las 3 propuestas de header</h3>
          <ul className="space-y-3 text-sm text-slate-700">
            <li><strong className="text-emerald-700">A · Compacto 3 filas</strong> — el ya validado: identidad oferta + escenarios + stepper. Sólido, equilibrado, sin sorpresas. Recomendado si valoras claridad por encima de todo.</li>
            <li><strong className="text-emerald-700">B · KPIs vivos</strong> — añade una banda con <strong>3 métricas clave del escenario activo (Ahorro periodo / Margen bruto / ROI)</strong> que se ven SIEMPRE, incluso estando en paso 1. El comercial ve los números mientras configura → feedback inmediato. Recomendado si tu prioridad es velocidad operativa.</li>
            <li><strong className="text-emerald-700">C · Minimalista</strong> — 1 sola fila densa con todo (logo + nombre + estado + escenarios + acciones), stepper abajo en sticky bar separada. Maximiza espacio para contenido. Recomendado si trabajáis en pantallas pequeñas o queréis menos &laquo;cromo&raquo;.</li>
          </ul>
        </div>
      </main>
    </div>
  );
}

// ============================================================================
// HEADER A — Compacto 3 filas (el ya enseñado · validado)
// ============================================================================
const HeaderA = ({ paso, setPaso }) => (
  <header className="bg-white border-b border-slate-200">
    <div className="max-w-[1500px] mx-auto px-6 py-3 flex items-center gap-3">
      <Leaf className="w-5 h-5 text-emerald-600 flex-shrink-0" />
      <h1 className="text-base font-bold text-slate-900 truncate">Oferta para TRANSPORTES GARCÍA</h1>
      <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-100 text-emerald-700 border border-emerald-200">v3</span>
      <span className="text-xs text-slate-500">· borrador · 30/06/2026</span>
      <div className="flex-1" />
      <BotonAsignar />
      <span className="w-px h-6 bg-slate-200" />
      <ChipGuardado />
      <BotonesAccion />
    </div>
    <BandaEscenarios />
    <StepperFuerte paso={paso} setPaso={setPaso} />
  </header>
);

// ============================================================================
// HEADER B — Con KPIs vivos del escenario activo (mi favorita)
// IMPL-039 ajuste: escenarios MOVIDOS a la fila 1 (junto a estado/fecha),
// los KPIs reflejan el escenario activo → jerarquía lógica.
// ============================================================================
const HeaderB = ({ paso, setPaso }) => (
  <header className="bg-white border-b border-slate-200">
    <div className="max-w-[1500px] mx-auto px-6 py-3 flex items-center gap-3 flex-wrap">
      <Leaf className="w-5 h-5 text-emerald-600 flex-shrink-0" />
      <h1 className="text-base font-bold text-slate-900 truncate">Oferta para TRANSPORTES GARCÍA</h1>
      <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-100 text-emerald-700 border border-emerald-200">v3</span>
      <span className="text-xs text-slate-500">· borrador · 30/06/2026</span>
      <span className="w-px h-5 bg-slate-200 mx-1" />
      <span className="text-[10px] font-bold uppercase tracking-wider text-emerald-700">Escenario:</span>
      <button className="px-3 py-1 rounded-full text-xs font-bold bg-emerald-600 text-white shadow-sm">Base</button>
      <button className="px-3 py-1 rounded-full text-xs font-medium bg-white border border-emerald-200 text-slate-700 hover:border-emerald-300">Opción Pro</button>
      <button className="px-3 py-1 rounded-full text-xs font-medium bg-white border border-emerald-200 text-slate-700 hover:border-emerald-300">Económica</button>
      <button className="px-3 py-1 rounded-full text-xs font-medium border-2 border-dashed border-emerald-300 text-emerald-700 hover:bg-white inline-flex items-center gap-1">
        <Plus className="w-3 h-3" /> Nuevo
      </button>
      <div className="flex-1" />
      <BotonAsignar />
      <span className="w-px h-6 bg-slate-200" />
      <ChipGuardado />
      <BotonesAccion />
    </div>

    {/* KPIs vivos del escenario seleccionado arriba */}
    <div className="bg-gradient-to-r from-emerald-50 via-emerald-50/50 to-emerald-50 border-y border-emerald-100">
      <div className="max-w-[1500px] mx-auto px-6 py-3 grid grid-cols-3 gap-4">
        <KpiVivo Icon={TrendingUp} label="Ahorro periodo" valor="26.626 €" delta="+18 %" color="emerald" />
        <KpiVivo Icon={Wallet}     label="Margen bruto"   valor="10.028 €" delta="37,6 %" color="amber" />
        <KpiVivo Icon={Target}     label="ROI"            valor="14 meses" delta="·" color="blue" />
      </div>
    </div>

    <StepperFuerte paso={paso} setPaso={setPaso} />
  </header>
);

const KpiVivo = ({ Icon, label, valor, delta, color }) => {
  const palette = {
    emerald: { iconBg: "bg-emerald-100", iconText: "text-emerald-600", valorText: "text-emerald-700", deltaBg: "bg-emerald-200/60 text-emerald-800" },
    amber:   { iconBg: "bg-amber-100",   iconText: "text-amber-600",   valorText: "text-amber-700",   deltaBg: "bg-amber-200/60 text-amber-800" },
    blue:    { iconBg: "bg-blue-100",    iconText: "text-blue-600",    valorText: "text-blue-700",    deltaBg: "bg-blue-200/60 text-blue-800" },
  }[color];
  return (
    <div className="flex items-center gap-3">
      <div className={`w-10 h-10 rounded-lg ${palette.iconBg} flex items-center justify-center flex-shrink-0`}>
        <Icon className={`w-5 h-5 ${palette.iconText}`} />
      </div>
      <div className="min-w-0">
        <p className="text-[10px] uppercase tracking-wider text-slate-500 font-bold">{label}</p>
        <div className="flex items-baseline gap-2">
          <p className={`text-lg font-black ${palette.valorText} leading-tight`}>{valor}</p>
          {delta !== "·" && <span className={`text-[10px] px-1.5 py-0.5 rounded ${palette.deltaBg} font-bold`}>{delta}</span>}
        </div>
      </div>
    </div>
  );
};

// ============================================================================
// HEADER C — Minimalista (1 fila densa + stepper sticky abajo)
// ============================================================================
const HeaderC = ({ paso, setPaso }) => (
  <header className="bg-white border-b border-slate-200">
    <div className="max-w-[1500px] mx-auto px-6 py-3 flex items-center gap-2 flex-wrap">
      <Leaf className="w-5 h-5 text-emerald-600 flex-shrink-0" />
      <h1 className="text-base font-bold text-slate-900 truncate">TRANSPORTES GARCÍA</h1>
      <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-100 text-emerald-700 border border-emerald-200">v3 · borrador</span>
      <span className="text-xs text-slate-400">30/06/26</span>
      <span className="w-px h-5 bg-slate-200 mx-1" />
      <span className="text-[10px] font-bold uppercase text-slate-400 mr-1">Esc</span>
      <button className="px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-emerald-600 text-white">Base</button>
      <button className="px-2.5 py-0.5 rounded-full text-[11px] bg-white border border-slate-300 text-slate-600">Opción Pro</button>
      <button className="px-2.5 py-0.5 rounded-full text-[11px] bg-white border border-slate-300 text-slate-600">Económica</button>
      <button className="px-2 py-0.5 rounded-full text-[11px] border-2 border-dashed border-slate-300 text-slate-500"><Plus className="w-3 h-3 inline" /></button>
      <div className="flex-1" />
      <BotonAsignar small />
      <ChipGuardado small />
      <button className="text-[11px] px-2 py-1 rounded bg-white border border-slate-300 text-slate-700 hover:bg-slate-50 inline-flex items-center gap-1"><Printer className="w-3 h-3" />Imprimir</button>
      <button className="text-[11px] px-2 py-1 rounded bg-white border border-slate-300 text-slate-700 hover:bg-slate-50 inline-flex items-center gap-1"><Plus className="w-3 h-3" />Versión</button>
      <button className="text-[11px] px-2 py-1 rounded bg-white border border-slate-300 text-slate-700 hover:bg-slate-50 inline-flex items-center gap-1"><History className="w-3 h-3" />Historial</button>
    </div>
    <StepperFuerte paso={paso} setPaso={setPaso} />
  </header>
);

// ============================================================================
// Subcomponentes compartidos
// ============================================================================
const BotonAsignar = ({ small }) => (
  <button className={`text-white rounded-md hover:opacity-90 transition ${small ? "px-1.5 py-1" : "px-2.5 py-1.5"}`} style={{ background: "#ec561c" }} title="Asignar a cliente">
    <UserPlus className={small ? "w-3 h-3" : "w-4 h-4"} />
  </button>
);

const ChipGuardado = ({ small }) => (
  <div className={`text-xs font-semibold rounded-lg bg-emerald-50 text-emerald-700 border border-emerald-200 inline-flex items-center gap-1.5 ${small ? "px-2 py-0.5 text-[10px]" : "px-3 py-1.5"}`}>
    <Check className={small ? "w-3 h-3" : "w-3.5 h-3.5"} /> Guardado
  </div>
);

const BotonesAccion = () => (
  <>
    <button className="text-xs px-3 py-1.5 rounded-lg bg-white border border-slate-300 text-slate-700 hover:bg-slate-50 inline-flex items-center gap-1.5">
      <Printer className="w-3.5 h-3.5" /> Imprimir
    </button>
    <button className="text-xs px-3 py-1.5 rounded-lg bg-white border border-slate-300 text-slate-700 hover:bg-slate-50 inline-flex items-center gap-1.5">
      <Plus className="w-3.5 h-3.5" /> Versión
    </button>
    <button className="text-xs px-3 py-1.5 rounded-lg bg-white border border-slate-300 text-slate-700 hover:bg-slate-50 inline-flex items-center gap-1.5">
      <History className="w-3.5 h-3.5" /> Historial
    </button>
  </>
);

const BandaEscenarios = () => (
  <div className="bg-emerald-50/60 border-y border-emerald-100">
    <div className="max-w-[1500px] mx-auto px-6 py-2 flex items-center gap-2 flex-wrap">
      <span className="text-[10px] font-bold uppercase tracking-wider text-emerald-700">Escenarios</span>
      <button className="px-3 py-1 rounded-full text-xs font-bold bg-emerald-600 text-white shadow-sm">Base</button>
      <button className="px-3 py-1 rounded-full text-xs font-medium bg-white border border-emerald-200 text-slate-700 hover:border-emerald-300">Opción Pro</button>
      <button className="px-3 py-1 rounded-full text-xs font-medium bg-white border border-emerald-200 text-slate-700 hover:border-emerald-300">Económica</button>
      <button className="px-3 py-1 rounded-full text-xs font-medium border-2 border-dashed border-emerald-300 text-emerald-700 hover:bg-white inline-flex items-center gap-1">
        <Plus className="w-3 h-3" /> Nuevo
      </button>
    </div>
  </div>
);

const StepperFuerte = ({ paso, setPaso }) => (
  <div className="bg-[#0a6640]">
    <div className="max-w-[1500px] mx-auto flex">
      {[
        { n: 1, label: "Configurar", Icon: Settings },
        { n: 2, label: "Números", Icon: Calculator },
      ].map((p, idx) => {
        const isActive = paso === p.n;
        return (
          <button
            key={p.n}
            onClick={() => setPaso(p.n)}
            data-testid={`mock-paso-${p.n}`}
            className={`flex-1 py-3 text-sm transition relative inline-flex items-center justify-center gap-2 ${
              isActive ? "bg-white text-[#0a6640] font-black shadow-inner" : "text-emerald-100/70 hover:text-white hover:bg-white/10 font-medium"
            } ${idx > 0 ? "border-l border-emerald-700/50" : ""}`}
          >
            <span className={`w-6 h-6 rounded-full inline-flex items-center justify-center text-[11px] font-black ${isActive ? "bg-[#0a6640] text-white" : "bg-emerald-700/30 text-emerald-100/80"}`}>{p.n}</span>
            <p.Icon className="w-4 h-4" />
            {p.label}
            {isActive && <span className="absolute bottom-0 left-0 right-0 h-1 bg-emerald-400" />}
          </button>
        );
      })}
    </div>
  </div>
);
